export const DELIVERY_LOCATION_KEY = 'asure_delivery_location';

export const getDeliveryLocation = () => {
    try {
        return JSON.parse(localStorage.getItem(DELIVERY_LOCATION_KEY) || 'null');
    } catch (_) {
        return null;
    }
};

export const saveDeliveryLocation = location => {
    localStorage.setItem(DELIVERY_LOCATION_KEY, JSON.stringify(location));
};

export const getProfilePostalCode = () => {
    try {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        return /^\d{6}$/.test(String(user.PostalCode || '')) ? String(user.PostalCode) : '';
    } catch (_) {
        return '';
    }
};
